import styled from "styled-components";

const Div = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h6`
  width: 25%;
  @media (max-width: 991px) {
    width: 25%;
  }
`;

const Select = styled.select`
  width: 45%;
  height: 2.5rem;
  border: 1px solid #ececec;
  border-radius: 10px;
  padding-left: 20px;
  :focus {
    border-color: #3bb77e !important;
    box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
  }
  @media (max-width: 1024px) {
    width: 80%;
  }

  @media (max-width: 991px) {
    width: 100%;
  }
`;

const ErrorMsg = styled.span`
  color: #dc3545;
`;

const CustomSelect = ({
  title,
  code,
  options,
  size,
  watch,
  register,
  formState,
  getValues,
  detailData,
}) => {
  const disableCheck = () => {
    if (code === "T0035") {
      return (
        detailData?.Row?.find((el) =>
          el.data.find((item) => item.code === "T0034" || item.code === "T0036")
        )
          ?.data.find((el) => el.code === "T0034" || el.code === "T0036")
          ?.options.filter((el) => el.matching === "none")
          ?.map((el) => el.okey)
          ?.includes(watch("T0034") || watch("T0036")) ||
        (watch("T0034") || watch("T0036")) == "" ||
        (watch("T0034") || watch("T0036")) == undefined
      );
    }
    if (code === "T0039") {
      return (
        detailData?.Row?.find((el) =>
          el.data.find((item) => item.code === "T0038")
        )
          ?.data.find((el) => el.code === "T0038")
          ?.options.filter((el) => el.matching === "none")
          ?.map((el) => el.okey)
          ?.includes(watch("T0038")) ||
        watch("T0038") == "" ||
        watch("T0038") == undefined
      );
    }
  };

  const matchingFilter = () => {
    const matching = detailData?.Row?.find((el) =>
      el?.data?.find((item) =>
        code === "T0035"
          ? item.code === "T0034" || item.code === "T0036"
          : item.code === "T0038"
      )
    )
      ?.data.find(
        (el) =>
          el.code === "T0034" || el.code === "T0036" || el.code === "T0038"
      )
      ?.options?.find(
        (option) =>
          option.okey == watch("T0034") ||
          option.okey == watch("T0036") ||
          option.okey == watch("T0038")
      )?.matching;

    if (code === "T0035" || code === "T0039") {
      return options?.filter((option) =>
        option.matching.split(",").includes(matching)
      );
    } else {
      return options;
    }
  };

  return (
    <>
      <Div>
        <Select
          id={code}
          name={title}
          className="form-select"
          defaultValue={""}
          disabled={disableCheck()}
          {...register(code)}
        >
          <option value={""} disabled>
            {disableCheck() ? "지종 선택 후" : title} 선택
          </option>
          {matchingFilter()?.map((el, i) => (
            <option key={i} value={el.okey}>
              {el.oname}
            </option>
          ))}
        </Select>
        <ErrorMsg>{formState?.errors[code]?.message}</ErrorMsg>
      </Div>
    </>
  );
};
export default CustomSelect;
